// ======================================================================
// File Name       : ContentNotificationAddMessage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Form, FormControl, Col, Button, Table, Modal } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import { Link } from 'react-router-dom';
import TableHead from '../TableHead';
import * as Path from '../../constants/PathConstants';
import { MODE, VALIDATE_TYPE, ROOT_URL } from '../../constants/index';
import FormControlValidate from '../../components/FormControlValidate';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FileUpload from '../../components/FileUpload';

class ContentNotificationAddMessage extends React.Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.validation = this.validation.bind(this);
    this.validateMessage = this.validateMessage.bind(this);
    this.onOkClick = this.onOkClick.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  validateMessage() {
    return Object.keys(this.refsAddMessage).every(
      ref => this.refsAddMessage[ref].validation && this.refsAddMessage[ref].validation(),
    );
  }
  onDelete(event) {
    const { id } = event.target;
    this.props.handleDelteMessage(id);
  }
  onEdit(event) {
    const { id } = event.target;
    this.props.handleEditMessage(id);
  }
  onOkClick() {
    const isValid = this.validateMessage();
    if (!isValid) {
      return;
    }
    this.props.handleOkClick();
  }
  render() {
    const {
      mode,
      handleChange,
      handleFileChange,
      messageZipFileName,
      timeCondition,
      handleOkClick,
      handleCancelClick,
      handleEditMessage,
      handleDelteMessage,
      handleAddMessage,
      notifyMessageList,
      showModal,
      enableAddButton,
    } = this.props;
    this.refsToValidate = [];
    this.refsAddMessage = [];
    const thead = [
      { title: '表示条件', sortBy: null },
      { title: 'メッセージファイル', sortBy: null },
      { title: '編集', sortBy: null },
      { title: '削除', sortBy: null, width: 100 },
    ];

    const isEditMode = mode === MODE.EDIT_MODE;
    const isNewMode = mode === MODE.NEW_MODE;
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    let notifyMessageTableData = null;
    let lengthToTest = '';
    if (notifyMessageList) {
      notifyMessageTableData = notifyMessageList.map((notifyMessagetData, index) => (
        <tr key={index}>
          <td className="padding-top-15 form-label">{notifyMessagetData.timeCondition} 秒経過</td>
          <td className="padding-top-15 form-label">{notifyMessagetData.messageZipFileName}</td>
          <td className="text-center">
            <Button
              id={index}
              onClick={this.onEdit}
              variant="primary"
              className="btn-96"
              disabled={!enableAddButton}
            >
              編集
            </Button>
          </td>
          <td className="text-center padding-top-15">
            <i
              role="button"
              className="bi bi-trash"
              id={index}
              onClick={this.onDelete}
            />
          </td>
        </tr>
      ));
      lengthToTest = notifyMessageTableData.length;
    }
    return (
      <div>
        <Form
          className="col-sm-12"
          onSubmit={(e) => {
            e.preventDefault();
            this.onOkClick();
          }}>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              通知メッセージ<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <Button variant="primary" className="btn-96" onClick={handleAddMessage.bind(this)}>
                追加
              </Button>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} />
            <Col sm={9}>
              <Table striped hover className="margin-top-10">
                <thead>
                  <TableHead data={thead} />
                </thead>
                <tbody>{notifyMessageTableData}</tbody>
              </Table>
            </Col>
          </Form.Group>
        </Form>
        {!lengthToTest && (
          <Col
            sm={{
              span: 9,
              offset: 3
            }}>
            <FormControlValidate
              label="通知メッセージ"
              validateType={VALIDATE_TYPE.LABEL}
              value={lengthToTest || ''}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required
            />
          </Col>
        )}
        {showModal && (
          <Modal className="modal-container" show={showModal} style={style} dialogClassName="content-notification-add-message-dialog">
            <Modal.Header onHide={handleCancelClick} closeButton>
              <Modal.Title className="text-center">
                通知メッセージを追加してください
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.onOkClick();
                  }}
                  className='form-horizontal'
                >
                  <Form.Group className="form-info padding-left-20">
                    <Col as={Form.Label} sm={4} className="padding-right-clear">
                      表示条件 <span className="required">&nbsp;(※)</span>
                    </Col>
                    <Col sm={4}>
                      <FormControlValidate
                        type="text"
                        name="timeCondition"
                        ref={(ref) => {
                          if (ref) {
                            this.refsAddMessage.push(ref);
                          }
                        }}
                        label="表示条件"
                        maxLength="4"
                        validateType={VALIDATE_TYPE.NUMERIC}
                        onChange={handleChange}
                        value={timeCondition}
                        messageError={MessageTemplate.MSG_NUMERIC_INVALID}
                        messageSuccess={MessageTemplate.MSG_NUMERIC_VALID}
                        required
                      />
                    </Col>
                    <Col sm={4} className="padding-left-right-clear form-label">
                      秒経過
                    </Col>
                  </Form.Group>
                  <Form.Group className="form-info padding-left-20">
                    <Col sm={4} className="padding-right-clear">
                      <Col sm={12} className="padding-left-right-clear">
                        メッセージファイル { messageZipFileName ? '' : <span className="required">&nbsp;(※)</span> }
                      </Col>
                      <Col sm={12} className="padding-left-right-clear margin-top-10">
                        <a
                          className="float-start"
                          role="button"
                          href={ROOT_URL + '/manual/csvsample/notifyMessage_content.zip'}
                        >
                          <u>サンプルダウンロード</u>
                        </a>
                      </Col>
                    </Col>
                    <Col sm={4} className="margin-top-5">
                      <FileUpload
                        labelName="ファイル選択"
                        onChange={handleFileChange}
                        fileName={messageZipFileName}
                        accept=".zip"
                      />
                    </Col>
                    <Col sm={4} className="padding-left-clear margin-top-5 form-label">
                      <FormControlValidate
                        label="ファイル選択"
                        validateType={VALIDATE_TYPE.LABEL}
                        value={messageZipFileName && `ファイル名：${messageZipFileName}`}
                        ref={(ref) => {
                          if (ref) {
                            this.refsAddMessage.push(ref);
                          }
                        }}
                        required
                      />
                    </Col>
                  </Form.Group>
                </Form>
              </div>
            </Modal.Body>
            <Modal.Footer className="text-center">
              <Button
                className=" margin-right-10 btn-96"
                variant="primary"
                onClick={handleCancelClick}
              >
                キャンセル
              </Button>
              <Button className=" margin-left-10 btn-96" variant="primary" onClick={this.onOkClick}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    );
  }
}
export default ContentNotificationAddMessage;
